import { SettingsSlice } from './types';
import type { RootState } from 'src/store/rootReducer';

export const selectSettings = (state: RootState): SettingsSlice =>
  state.settings;

export const selectPusherSessionId = (state: RootState): string =>
  state.settings.pusherSessionId;
